import React from 'react';
import { Typography, Box, Switch } from '@mui/material';
import { Moon, Sun } from 'lucide-react';

const Settings = ({ darkMode, setDarkMode }) => {
  const handleToggle = () => {
    setDarkMode(prev => !prev);
  };

  return (
    <Box className="fade-in" sx={{ maxWidth: 560, mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 0.5, fontWeight: 700, letterSpacing: '-0.02em' }}>
        Settings
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
        Manage your preferences
      </Typography>

      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2.5,
            py: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {darkMode ? <Moon size={18} /> : <Sun size={18} />}
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                Dark Mode
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Switch between light and dark theme
              </Typography>
            </Box>
          </Box>
          <Switch
            checked={darkMode}
            onChange={handleToggle}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: '#2383e2',
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#2383e2',
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Settings;
